import React from 'react'
const SeccionDatosCenter = (props) => {
    return <div className="p-grid p-justify-center text-center">
        {props.children}
    </div>
}
export default SeccionDatosCenter;
